import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import clsx from "clsx";
import { themeTypeToBool } from '../../../utils/helpers';
import { TooltipRight } from "../../Common/CustomTooltips";
import t from "../../../languages/pl";

const useStyles = makeStyles((theme) => ({
    shape: {
        height: 16,
        width: 16,
        margin: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.primary.main,
        fontSize: 10,
        color: themeTypeToBool(theme.palette.type) ? "#E5E5E5" : "#43425D"
    },
    shapeCircle: {
        borderRadius: '50%',
    },
}));


function ArchivedAvatar() {
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <TooltipRight title={t.vehicleArchived}>
            <div
                className={clsx(classes.shape, classes.shapeCircle)}
            >
                A
            </div>
        </TooltipRight>
    );
}

export default ArchivedAvatar;

